import {SVGProps} from "types/SVG";

export const MotoDiagram = ({alt, className}: SVGProps) => (
    <svg width="154" height="356" viewBox="0 0 154 356" fill="none" xmlns="http://www.w3.org/2000/svg"
         className={className}
    >
        <path
            d="M96.4205 202.149C92.6938 202.149 89.5714 199.933 89.5714 197.113C89.4707 194.293 92.996 191.976 96.4205 192.077C101.658 192.882 118.579 189.156 118.781 197.113C118.68 205.07 101.255 201.242 96.4205 202.149Z"
            fill="#1F3544"/>
        <path
            d="M56.8368 192.077C60.5635 192.077 63.6858 194.292 63.6858 197.113C63.7865 199.933 60.2613 202.249 56.8368 202.149C51.5992 201.343 34.678 205.07 34.4766 197.113C34.678 189.156 52.1028 192.983 56.8368 192.077Z"
            fill="#1F3544"/>
        <path
            d="M50.5917 312.74C47.7715 312.74 45.5557 309.819 45.5557 306.193V182.406C45.5557 178.78 47.7715 175.859 50.5917 175.859C53.4119 175.859 55.6278 178.78 55.6278 182.406V306.193C55.6278 309.819 53.3112 312.74 50.5917 312.74Z"
            fill="#7195B4"/>
        <path
            d="M57.4411 162.162H95.7153C100.348 162.162 104.176 165.99 104.176 170.623V266.308C104.176 270.941 100.348 274.769 95.7153 274.769H57.4411C52.8079 274.769 48.9805 270.941 48.9805 266.308V170.623C48.8797 165.99 52.7072 162.162 57.4411 162.162Z"
            fill="url(#paint0_linear_3676_31855)"/>
        <path
            d="M76.8802 154.508H38.9082C39.1096 155.817 39.3111 156.623 39.3111 156.623L58.146 226.322L76.8802 228.74V154.508Z"
            fill="url(#paint1_linear_3676_31855)"/>
        <path
            d="M76.8808 154.607V95.1816L64.7942 98.5055C62.9812 102.836 38.5058 135.672 38.7073 150.075C38.7073 151.082 39.2109 153.701 39.5131 154.507H76.8808V154.607Z"
            fill="url(#paint2_linear_3676_31855)"/>
        <path
            d="M41.1248 151.485C50.7941 131.743 60.967 112.103 76.0752 95.3828L64.7944 98.5052C64.7944 98.5052 41.1248 135.671 39.3119 142.823C37.4989 150.377 39.3119 156.622 39.4126 157.125C39.8155 155.211 40.4198 153.298 41.1248 151.485Z"
            fill="url(#paint3_linear_3676_31855)"/>
        <path
            d="M76.1758 154.508V228.84L94.91 226.423L113.745 156.724C113.745 156.724 113.946 155.918 114.148 154.609H76.1758V154.508Z"
            fill="url(#paint4_linear_3676_31855)"/>
        <path
            d="M113.745 154.708C113.745 153.902 114.349 151.989 114.45 151.082C115.356 137.082 90.0752 102.736 88.363 98.5055L76.2764 95.1816V154.607H113.745V154.708Z"
            fill="url(#paint5_linear_3676_31855)"/>
        <path
            d="M111.932 151.485C102.263 131.743 92.0897 112.103 76.9814 95.3828L88.2623 98.5052C88.2623 98.5052 111.932 135.671 113.745 142.823C115.558 150.377 113.745 156.622 113.644 157.125C113.241 155.211 112.637 153.298 111.932 151.485Z"
            fill="url(#paint6_linear_3676_31855)"/>
        <path
            d="M76.9816 226.724C72.3484 226.724 58.0459 230.451 58.0459 226.422L68.5209 105.757C68.5209 101.729 72.3484 98.5055 76.9816 98.5055C82.1184 97.8004 88.3631 100.419 88.2624 105.757L97.428 198.421C98.536 209.199 93.2985 219.774 83.9314 225.012C81.3126 226.523 78.7945 227.228 76.9816 226.724Z"
            fill="#7195B4"/>
        <path
            d="M76.9814 226.724C78.7944 227.228 81.3125 226.523 83.9312 225.012C93.399 219.774 98.5358 209.198 97.4279 198.421L93.8019 161.154H63.7869L58.1465 226.422C58.1465 230.451 72.3482 226.724 76.9814 226.724Z"
            fill="#37556D"/>
        <path d="M105.989 93.3692C100.65 70.7068 57.1386 66.4765 45.5557 94.2757L105.989 93.3692Z"
              fill="url(#paint7_linear_3676_31855)"/>
        <path
            d="M101.457 81.3822C99.7444 81.3822 98.3343 82.7923 98.3343 84.5046C98.8379 87.2241 96.5213 96.1883 101.457 96.0876C103.169 96.0876 104.579 94.6775 104.579 92.9652C103.975 90.145 106.291 81.1808 101.457 81.3822Z"
            fill="url(#paint8_linear_3676_31855)"/>
        <path
            d="M51.5993 81.3822C49.887 81.3822 48.4769 82.7923 48.4769 84.5046C48.9805 87.2241 46.6639 96.1883 51.5993 96.0876C53.3116 96.0876 54.7217 94.6775 54.7217 92.9652C54.218 90.145 56.5346 81.1808 51.5993 81.3822Z"
            fill="url(#paint9_linear_3676_31855)"/>
        <path
            d="M52.9092 72.6191C57.4417 74.13 58.9525 81.3819 58.9525 81.3819C60.3626 87.8281 58.9525 90.4469 52.9092 90.3461V72.6191Z"
            fill="white"/>
        <path
            d="M74.2624 109.686C69.6292 109.686 65.8018 105.355 65.8018 99.9158V18.8349C65.8018 13.396 69.5285 0 74.2624 0H78.7948C83.428 0 87.2555 14.0003 87.2555 19.4393V99.9158C87.054 108.175 80.91 110.391 74.2624 109.686Z"
            fill="#37556D"/>
        <path
            d="M88.2621 99.9165V54.5918H64.7939V99.9165C64.7939 105.255 68.9235 109.687 74.0603 109.687C81.3123 110.392 88.0606 108.176 88.2621 99.9165Z"
            fill="url(#paint10_linear_3676_31855)"/>
        <path
            d="M75.3699 91.4544C71.5425 91.4544 65.8014 93.0659 64.5927 88.5334L62.4775 65.9718C62.4775 55.396 77.4851 59.4249 83.8305 58.7198C87.6579 58.7198 90.6796 61.9429 90.6796 65.9718L88.5644 88.5334C88.1615 93.771 80.0031 92.0587 75.3699 91.4544Z"
            fill="url(#paint11_linear_3676_31855)"/>
        <path
            d="M84.0325 58.9208C82.1188 58.6186 77.8885 58.6186 76.4784 58.6186C74.9676 58.6186 71.1402 58.5179 69.2264 58.9208C64.7947 59.6258 61.6723 61.9424 62.881 68.2879H76.4784H76.6798H90.5794C91.5866 61.9424 88.3636 59.6258 84.0325 58.9208Z"
            fill="url(#paint12_linear_3676_31855)"/>
        <path
            d="M90.3765 68.2901C90.3765 67.8872 90.6787 65.772 90.5779 65.3691H62.4766C62.3759 65.772 62.6781 67.7865 62.6781 68.2901H90.3765Z"
            fill="url(#paint13_linear_3676_31855)"/>
        <path
            d="M77.3844 113.11L78.5931 85.8145C62.8805 85.8145 45.8585 93.3686 31.2539 102.232L33.1676 106.765C33.1676 106.765 50.391 102.031 54.017 105.254C57.5422 108.578 70.5353 114.218 77.3844 113.11Z"
            fill="url(#paint14_linear_3676_31855)"/>
        <path
            d="M12.0156 113.312C10.9077 113.614 9.79976 113.211 9.19543 112.204C8.79254 111.599 8.5911 110.794 8.49038 110.089C8.28894 108.981 8.79254 107.973 9.69904 107.47C14.7351 104.851 30.9513 101.427 32.0592 101.024C34.2751 100.319 33.8722 104.347 34.4765 105.455C34.678 106.16 34.7787 106.765 34.0737 106.966L12.0156 113.312Z"
            fill="#37556D"/>
        <path
            d="M59.2551 81.3843C55.0248 64.8659 42.4346 73.3265 44.449 87.5283C44.6505 88.7369 45.4563 89.6434 46.5642 89.9456C49.6866 90.6506 55.2262 90.6506 57.6436 89.5427C59.4566 88.7369 59.9602 84.4059 59.2551 81.3843Z"
            fill="url(#paint15_linear_3676_31855)"/>
        <path
            d="M57.9452 89.2412C59.1539 88.6368 59.7582 86.6224 59.6575 84.2051H44.2471C44.2471 85.8166 44.2471 86.8238 44.5492 88.1332C44.7507 88.939 45.2543 89.5433 46.0601 89.7448C48.8803 90.6513 55.2257 90.5505 57.8445 89.3419L57.9452 89.2412Z"
            fill="#7195B4"/>
        <path
            d="M53.1113 72.5215C57.6438 73.9316 59.1546 81.385 59.1546 81.385C60.5647 87.8312 59.1546 90.4499 53.1113 90.3492V72.5215Z"
            fill="#37556D"/>
        <path
            d="M95.6152 89.4411C98.1332 90.5491 103.572 90.6498 106.695 89.844C107.802 89.5419 108.709 88.6354 108.81 87.4267C110.925 73.225 98.3347 64.7643 94.0036 81.2827C93.2986 84.4051 93.9029 88.7361 95.6152 89.4411Z"
            fill="url(#paint16_linear_3676_31855)"/>
        <path
            d="M95.5143 89.3419C98.133 90.5505 104.478 90.6513 107.299 89.7448C108.104 89.5433 108.608 88.939 108.809 88.1332C109.112 86.7231 109.112 85.8166 109.112 84.2051H93.7013C93.6005 86.6224 94.2049 88.6368 95.4135 89.2412L95.5143 89.3419Z"
            fill="#7195B4"/>
        <path
            d="M100.148 90.3473C94.105 90.448 92.6949 87.8292 94.105 81.383C94.105 81.383 95.6158 73.9296 100.148 72.5195V90.3473Z"
            fill="#37556D"/>
        <path
            d="M34.88 108.074C34.4771 108.175 34.0743 108.074 34.0743 107.772L31.8584 100.016C31.7577 99.7141 32.0598 99.4119 32.4627 99.3112C32.8656 99.2105 33.2685 99.3112 33.2685 99.6134L35.4844 107.369C35.4844 107.671 35.2829 107.973 34.88 108.074Z"
            fill="#1F3544"/>
        <path
            d="M76.5781 113.11L78.5926 85.8145C92.19 86.0159 110.018 94.9801 123.615 102.736L119.989 106.765C119.989 106.765 102.766 102.031 99.1398 105.254C95.5138 108.578 83.4272 114.218 76.5781 113.11Z"
            fill="url(#paint17_linear_3676_31855)"/>
        <path
            d="M118.881 107.066C118.075 106.864 118.176 106.26 118.478 105.555C119.082 104.346 118.679 100.317 120.895 101.123C122.003 101.627 138.219 105.051 143.255 107.569C144.263 108.073 144.766 109.181 144.464 110.188C144.363 110.893 144.061 111.699 143.759 112.303C143.155 113.21 142.047 113.713 140.939 113.411L118.881 107.066Z"
            fill="#37556D"/>
        <path
            d="M118.176 108.074C118.579 108.175 118.981 108.074 118.981 107.772L121.197 100.016C121.298 99.7141 120.996 99.4119 120.593 99.3112C120.19 99.2105 119.787 99.3112 119.787 99.6134L117.571 107.369C117.571 107.671 117.773 107.973 118.176 108.074Z"
            fill="#1F3544"/>
        <path
            d="M77.0819 112.304C60.0599 112.103 60.0599 95.3831 77.0819 95.1816C94.1038 95.4838 94.1038 112.103 77.0819 112.304Z"
            fill="url(#paint18_linear_3676_31855)"/>
        <path
            d="M77.082 112.304C64.2904 112.203 64.2904 99.4113 77.082 99.3105C89.8737 99.4113 89.8737 112.304 77.082 112.304Z"
            fill="url(#paint19_linear_3676_31855)"/>
        <path
            d="M53.2105 278.394C52.1026 278.394 51.1961 276.581 51.1961 274.265C50.9946 271.746 52.7069 269.833 53.3112 270.135C54.3184 270.135 97.7294 270.135 97.8302 270.135C98.9381 270.236 99.8446 272.049 99.8446 274.265C99.8446 276.48 98.9381 278.394 97.8302 278.394H53.2105Z"
            fill="#7195B4"/>
        <path
            d="M69.1253 294.007C69.7296 294.007 70.334 292.798 70.334 291.388C70.4347 289.877 69.5282 288.669 69.1253 288.77C68.7224 288.77 52.607 288.77 52.607 288.77C52.0026 288.87 51.499 289.978 51.499 291.388C51.499 292.798 52.0026 294.007 52.7077 294.007H69.1253Z"
            fill="#7195B4"/>
        <path d="M57.5416 288.869H52.5055C51.4983 288.869 50.5918 289.675 50.5918 290.783V296.02H57.5416V288.869Z"
              fill="#37556D"/>
        <path
            d="M45.9597 303.776C50.3914 320.798 63.6867 311.23 60.4636 296.122C59.5571 294.51 50.2907 294.208 47.0676 295.719C45.3554 296.625 45.2546 300.755 45.9597 303.776Z"
            fill="#37556D"/>
        <path
            d="M47.0667 295.818C45.858 296.423 45.4551 298.638 45.5558 301.056H61.067C61.2684 299.041 61.067 297.329 60.4626 296.221C59.5561 294.61 50.2897 294.307 47.0667 295.818Z"
            fill="#7195B4"/>
        <path
            d="M52.0028 312.64C47.4703 311.129 45.9595 303.877 45.9595 303.877C44.5494 297.532 45.9595 294.812 52.0028 294.913V312.64Z"
            fill="white"/>
        <path
            d="M52.0028 312.639C47.3696 311.229 45.9595 303.776 45.9595 303.776C44.5494 297.43 45.9595 294.711 52.0028 294.811V312.639Z"
            fill="url(#paint20_linear_3676_31855)"/>
        <path d="M96.9238 288.869H101.658C102.665 288.869 103.571 289.675 103.571 290.783V296.02H96.9238V288.869Z"
              fill="#37556D"/>
        <path
            d="M108.205 303.776C108.91 300.855 108.709 297.128 107.198 296.121C107.097 296.121 106.997 296.02 106.896 296.02C106.392 295.819 105.99 295.315 105.184 295.114C101.155 294.308 94.4066 294.711 93.7015 296.121C90.4784 311.229 103.774 320.899 108.205 303.776Z"
            fill="#37556D"/>
        <path
            d="M93.7004 296.222C93.096 297.33 92.8946 299.042 93.096 301.057H108.607C108.708 299.143 108.003 297.431 107.197 296.524C106.996 296.323 106.996 296.021 106.794 295.92C106.19 295.618 105.586 295.316 104.679 295.114C100.65 294.409 94.4054 294.913 93.7004 296.222Z"
            fill="#7195B4"/>
        <path
            d="M102.161 294.913C108.204 294.812 109.615 297.431 108.204 303.877C108.204 303.877 106.694 311.431 102.161 312.741V294.913Z"
            fill="url(#paint21_linear_3676_31855)"/>
        <path
            d="M98.2336 281.819C89.068 281.819 89.068 267.919 98.2336 267.818C107.399 267.818 107.399 281.718 98.2336 281.819Z"
            fill="url(#paint22_linear_3676_31855)"/>
        <path
            d="M55.9309 281.819C46.7652 281.819 46.7652 267.919 55.9309 267.818C64.9958 267.818 64.9958 281.718 55.9309 281.819Z"
            fill="url(#paint23_linear_3676_31855)"/>
        <path
            d="M74.8659 355.849C70.2327 355.849 66.4053 351.518 66.4053 346.18V265.099C66.4053 259.76 70.2327 246.264 74.8659 246.264H79.3984C84.0316 246.264 87.859 260.264 87.859 265.703V346.18C87.7582 354.338 81.6142 356.655 74.8659 355.849Z"
            fill="url(#paint24_linear_3676_31855)"/>
        <path
            d="M68.8226 323.82C68.0168 323.618 67.211 323.417 66.4053 323.115V346.18C66.4053 351.518 70.2327 355.849 74.8659 355.849C81.5135 356.655 87.6575 354.339 87.859 346.18V320.496C82.42 324.021 75.1681 325.23 68.8226 323.82Z"
            fill="#37556D"/>
        <path d="M88.5648 315.662H65.8018V337.922H88.5648V315.662Z" fill="url(#paint25_linear_3676_31855)"/>
        <path d="M88.5648 315.662H65.8018V324.526H88.5648V315.662Z" fill="url(#paint26_linear_3676_31855)"/>
        <path d="M88.5644 315.662H82.8232V337.922H88.5644V315.662Z" fill="white"/>
        <path d="M88.5646 315.662H82.6221V337.922H88.5646V315.662Z" fill="url(#paint27_linear_3676_31855)"/>
        <path
            d="M88.9661 260.968C108.506 262.177 102.564 238.91 99.139 227.025C96.8224 217.557 95.0094 210.507 92.1892 201.341C90.8798 197.01 89.8726 192.176 88.3618 187.844C87.8582 186.132 87.0524 184.521 86.0452 183.111C81.2105 176.463 73.2535 175.859 68.016 182.003C66.7066 183.614 65.8001 185.427 65.1958 187.442C60.4619 203.053 45.1522 246.867 52.5049 256.335C58.9511 263.486 66.8073 260.163 76.5773 260.767C79.2968 260.868 88.9661 260.968 88.9661 260.968Z"
            fill="#577A93"/>
        <path
            d="M88.9661 259.459C108.506 260.667 102.564 237.401 99.139 225.515C96.8224 216.048 95.0094 208.997 92.1892 199.831C90.8798 195.5 89.8726 190.666 88.3618 186.335C87.8582 184.622 87.0524 183.011 86.0452 181.601C81.2105 174.953 73.2535 174.349 68.016 180.493C66.7066 182.104 65.8001 183.917 65.1958 185.932C60.4619 201.544 45.1522 245.358 52.5049 254.825C58.9511 261.977 66.8073 258.653 76.5773 259.257C79.2968 259.358 88.9661 259.459 88.9661 259.459Z"
            fill="#7195B4"/>
        <path
            d="M97.0251 323.216V267.617C97.0251 263.085 93.1977 259.459 88.5645 259.459H65.8014C61.1682 259.459 57.3408 263.085 57.3408 267.617V323.216C57.3408 327.748 61.1682 331.374 65.8014 331.374H88.4638C93.1977 331.374 97.0251 327.748 97.0251 323.216ZM67.6144 329.058C63.5856 329.058 60.3625 325.734 60.3625 321.503V270.438C60.3625 266.308 63.5856 262.884 67.6144 262.884H87.0537C91.0826 262.884 94.3056 266.308 94.3056 270.438V321.503C94.3056 325.633 91.0826 329.058 87.0537 329.058H67.6144Z"
            fill="#37556D"/>
        <path
            d="M59.1536 281.617C58.1464 281.617 57.3406 280.811 57.3406 279.804C57.1392 278.696 58.8515 277.89 59.1536 277.991C59.9594 277.991 94.4062 277.991 94.5069 277.991C95.4134 277.991 96.2192 278.797 96.2192 279.804C96.2192 280.811 95.4134 281.617 94.4062 281.617H59.1536Z"
            fill="#37556D"/>
        <path
            d="M59.1536 298.941C58.1464 298.941 57.3406 298.135 57.3406 297.128C57.1392 296.02 58.8515 295.214 59.1536 295.315C59.9594 295.315 94.4062 295.315 94.5069 295.315C95.4134 295.315 96.2192 296.121 96.2192 297.128C96.2192 298.135 95.4134 298.941 94.4062 298.941H59.1536Z"
            fill="#37556D"/>
        <path
            d="M59.1536 316.265C58.1464 316.265 57.3406 315.46 57.3406 314.452C57.1392 313.344 58.8515 312.539 59.1536 312.639C59.9594 312.639 94.4062 312.639 94.5069 312.639C95.4134 312.639 96.2192 313.445 96.2192 314.452C96.2192 315.46 95.4134 316.265 94.4062 316.265H59.1536Z"
            fill="#37556D"/>
        <path
            d="M12.3184 81.2822C12.9227 78.462 15.34 80.0735 19.8725 80.275C26.3187 81.0807 38.3045 82.3901 39.6139 82.3901C41.8298 82.3901 42.0312 83.8002 42.0312 83.9009L47.168 104.448L46.5637 104.549L41.4269 84.0017C41.4269 83.9009 41.2255 82.9945 39.5132 82.9945C38.1031 82.9945 26.5201 81.6851 19.671 80.7786C16.4479 80.6779 13.1241 79.167 12.822 81.1815L12.3184 81.2822Z"
            fill="#37556D" stroke="#37556D" stroke-width="0.75" stroke-miterlimit="10"/>
        <path
            d="M12.6195 88.8363C29.2386 88.232 29.44 80.7786 12.5188 81.2822C-4.10029 81.8865 -4.20101 89.3399 12.6195 88.8363Z"
            fill="url(#paint28_linear_3676_31855)"/>
        <path
            d="M12.62 88.8357C5.46879 88.9365 -0.47378 87.7278 0.0298281 85.0083C1.94354 88.9365 23.9008 88.1307 24.9081 83.9004C26.2174 87.0228 19.7713 88.4329 12.62 88.8357Z"
            fill="#37556D"/>
        <path
            d="M140.839 81.2811C140.537 79.2666 137.213 80.7775 133.99 80.8782C127.141 81.684 115.558 83.0941 114.148 83.0941C112.536 83.0941 112.335 84.1013 112.234 84.1013L107.097 104.648L106.493 104.548L111.63 84.0006C111.63 83.8998 111.932 82.4897 114.047 82.4897C115.457 82.4897 127.343 81.0796 133.789 80.3746C138.321 80.1731 140.739 78.5616 141.343 81.3818L140.839 81.2811Z"
            fill="#37556D" stroke="#37556D" stroke-width="0.75" stroke-miterlimit="10"/>
        <path
            d="M141.141 81.2814C124.219 80.8785 124.421 88.3319 141.04 88.8355C157.961 89.3391 157.86 81.8857 141.141 81.2814Z"
            fill="url(#paint29_linear_3676_31855)"/>
        <path
            d="M128.751 83.9004C129.759 88.1307 151.716 88.9365 153.63 85.0083C154.133 87.7278 148.191 88.9365 141.039 88.8357C133.989 88.4329 127.543 87.0228 128.751 83.9004Z"
            fill="#37556D"/>
        <path
            d="M84.2328 191.371L82.4199 183.313C82.1177 181.903 80.8083 180.795 79.2975 180.795H74.1607C72.6499 180.795 71.3405 181.802 71.0383 183.313L69.2253 191.371C68.9232 192.579 69.8297 193.788 71.139 193.788H82.4199C83.5278 193.788 84.4343 192.579 84.2328 191.371Z"
            fill="#1F3544"/>
        <path
            d="M82.3193 193.082H71.0385C70.0313 193.082 69.3262 192.377 69.1248 191.471C68.9233 192.679 69.8298 193.787 71.0385 193.787H82.3193C83.528 193.787 84.4345 192.679 84.233 191.471C84.0316 192.377 83.2258 193.082 82.3193 193.082Z"
            fill="#577A93"/>
        <path
            d="M88.0612 208.19L85.8453 198.52C85.5432 197.312 84.536 196.506 83.2266 196.506H70.0321C68.8234 196.506 67.7155 197.312 67.4133 198.52L65.1974 208.19C64.7945 209.801 66.1039 211.413 67.8162 211.413H85.4425C87.1547 211.413 88.3634 209.801 88.0612 208.19Z"
            fill="#1F3544"/>
        <path
            d="M85.4417 210.608H67.9161C66.6067 210.608 65.4988 209.601 65.2974 208.393C65.0959 210.004 66.3046 211.414 67.9161 211.414H85.5424C87.1539 211.414 88.3626 210.004 88.1612 208.393C87.859 209.601 86.8518 210.608 85.4417 210.608Z"
            fill="#577A93"/>
        <path
            d="M92.3908 227.43L89.8728 216.451C89.5706 215.041 88.362 214.135 86.9519 214.135H66.3039C64.8938 214.135 63.6852 215.142 63.383 216.451L60.865 227.43C60.4621 229.344 61.8722 231.157 63.7859 231.157H89.4699C91.3836 231.157 92.8944 229.344 92.3908 227.43Z"
            fill="#577A93"/>
        <path
            d="M89.874 216.451C89.5719 215.041 88.3632 214.135 86.9531 214.135H66.3052C64.8951 214.135 63.6864 215.142 63.3843 216.451L60.8662 227.43C60.8662 227.531 60.8662 227.631 60.8662 227.732C61.0677 229.142 62.2763 230.351 63.8879 230.351H89.5719C91.0827 230.351 92.3921 229.142 92.5935 227.732C92.5935 227.631 92.5935 227.531 92.5935 227.43L89.874 216.451Z"
            fill="#1F3544"/>
        <path
            d="M90.9812 233.875H62.3763C60.664 233.875 59.1532 235.084 58.7503 236.796L55.8294 249.789C55.3258 251.803 56.9373 253.717 58.9517 253.717H94.4057C96.4202 253.717 98.0317 251.803 97.5281 249.789L94.5065 236.695C94.2043 235.084 92.6935 233.875 90.9812 233.875Z"
            fill="#1F3544"/>
        <path
            d="M94.4054 252.509H58.9514C57.3399 252.509 56.0305 251.301 55.829 249.891C55.4261 251.804 56.937 253.617 58.9514 253.617H94.4054C96.4198 253.617 97.9307 251.804 97.5278 249.891C97.2256 251.301 96.0169 252.509 94.4054 252.509Z"
            fill="#577A93"/>
        <defs>
            <linearGradient id="paint0_linear_3676_31855" x1="76.5301" y1="313.755" x2="76.5301" y2="214.026"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0706489" stop-color="#88A9E7"/>
                <stop offset="0.2341" stop-color="#9CB5DF"/>
                <stop offset="0.4189" stop-color="#ABBDDA"/>
                <stop offset="0.6409" stop-color="#B3C2D7"/>
                <stop offset="1" stop-color="#B6C3D6"/>
            </linearGradient>
            <linearGradient id="paint1_linear_3676_31855" x1="57.8942" y1="182.083" x2="57.8942" y2="127.453"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint2_linear_3676_31855" x1="57.7938" y1="200.07" x2="57.7938" y2="29.1786"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint3_linear_3676_31855" x1="38.521" y1="126.296" x2="76.0587" y2="126.296"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint4_linear_3676_31855" x1="95.1686" y1="182.083" x2="95.1686" y2="127.453"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint5_linear_3676_31855" x1="95.3015" y1="200.28" x2="95.3015" y2="29.0468"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint6_linear_3676_31855" x1="109.472" y1="126.296" x2="81.1353" y2="126.296"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint7_linear_3676_31855" x1="75.7442" y1="89.0869" x2="75.7442" y2="65.7638"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#3174C0"/>
                <stop offset="0.1499" stop-color="#4180C7"/>
                <stop offset="0.439" stop-color="#6B9ED8"/>
                <stop offset="0.8378" stop-color="#AFCFF3"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint8_linear_3676_31855" x1="98.211" y1="88.6809" x2="104.625" y2="88.6809"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint9_linear_3676_31855" x1="48.4283" y1="88.6809" x2="54.8427" y2="88.6809"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint10_linear_3676_31855" x1="64.7759" y1="82.2193" x2="88.2845" y2="82.2193"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint11_linear_3676_31855" x1="62.4342" y1="75.3898" x2="90.6257" y2="75.3898"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint12_linear_3676_31855" x1="76.5415" y1="58.3453" x2="76.5415" y2="68.9902"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint13_linear_3676_31855" x1="76.5285" y1="70.1755" x2="76.5285" y2="57.3708"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#3174C0"/>
                <stop offset="0.1499" stop-color="#4180C7"/>
                <stop offset="0.439" stop-color="#6B9ED8"/>
                <stop offset="0.8378" stop-color="#AFCFF3"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint14_linear_3676_31855" x1="54.8474" y1="103.021" x2="54.8474" y2="79.6996"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0706489" stop-color="#88A9E7"/>
                <stop offset="0.2341" stop-color="#9CB5DF"/>
                <stop offset="0.4189" stop-color="#ABBDDA"/>
                <stop offset="0.6409" stop-color="#B3C2D7"/>
                <stop offset="1" stop-color="#B6C3D6"/>
            </linearGradient>
            <linearGradient id="paint15_linear_3676_31855" x1="61.2994" y1="78.5722" x2="34.5666" y2="87.6726"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint16_linear_3676_31855" x1="92.0198" y1="78.5714" x2="118.753" y2="87.6718"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint17_linear_3676_31855" x1="100.021" y1="103.021" x2="100.021" y2="79.6996"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0706489" stop-color="#88A9E7"/>
                <stop offset="0.2341" stop-color="#9CB5DF"/>
                <stop offset="0.4189" stop-color="#ABBDDA"/>
                <stop offset="0.6409" stop-color="#B3C2D7"/>
                <stop offset="1" stop-color="#B6C3D6"/>
            </linearGradient>
            <linearGradient id="paint18_linear_3676_31855" x1="77.0966" y1="122.076" x2="77.0966" y2="93.7855"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint19_linear_3676_31855" x1="77.0966" y1="118.283" x2="77.0966" y2="81.5015"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#3174C0"/>
                <stop offset="0.1499" stop-color="#4180C7"/>
                <stop offset="0.439" stop-color="#6B9ED8"/>
                <stop offset="0.8378" stop-color="#AFCFF3"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint20_linear_3676_31855" x1="45.4662" y1="303.77" x2="52.0357" y2="303.77"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint21_linear_3676_31855" x1="108.694" y1="303.769" x2="102.124" y2="303.769"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint22_linear_3676_31855" x1="98.2445" y1="263.986" x2="98.2445" y2="307.059"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint23_linear_3676_31855" x1="55.8925" y1="263.986" x2="55.8925" y2="307.059"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint24_linear_3676_31855" x1="77.1713" y1="268.252" x2="77.1713" y2="364.601"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint25_linear_3676_31855" x1="65.8212" y1="326.799" x2="88.5356" y2="326.799"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#3174C0"/>
                <stop offset="0.1499" stop-color="#4180C7"/>
                <stop offset="0.439" stop-color="#6B9ED8"/>
                <stop offset="0.8378" stop-color="#AFCFF3"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint26_linear_3676_31855" x1="55.0116" y1="320.097" x2="93.8817" y2="320.097"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#3174C0"/>
                <stop offset="0.1499" stop-color="#4180C7"/>
                <stop offset="0.439" stop-color="#6B9ED8"/>
                <stop offset="0.8378" stop-color="#AFCFF3"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint27_linear_3676_31855" x1="133.928" y1="326.799" x2="45.5689" y2="326.799"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#3174C0"/>
                <stop offset="0.1499" stop-color="#4180C7"/>
                <stop offset="0.439" stop-color="#6B9ED8"/>
                <stop offset="0.8378" stop-color="#AFCFF3"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint28_linear_3676_31855" x1="0.18052" y1="83.8988" x2="25.0245" y2="86.2921"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
            <linearGradient id="paint29_linear_3676_31855" x1="153.559" y1="83.8979" x2="128.715" y2="86.2911"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA3EB"/>
                <stop offset="0.0304411" stop-color="#84A8ED"/>
                <stop offset="0.1646" stop-color="#9EBEF3"/>
                <stop offset="0.3123" stop-color="#B2CFF9"/>
                <stop offset="0.4782" stop-color="#C1DBFC"/>
                <stop offset="0.6776" stop-color="#C9E2FE"/>
                <stop offset="1" stop-color="#CCE4FF"/>
            </linearGradient>
        </defs>
    </svg>

);
